export enum ProductType {
  APP = 'app',
  Website = 'website',
  WXGame = 'wxgame',
}
